import { callDecimal } from "../utils.ts";

export interface Term {
  active: boolean;
  // e.g. "2040-12-31"
  endOn: string;
  id: string;
  institutionProgram:
    | "flexible_access"
    | "equitable_access"
    | "inclusive_access";
  name: string;
  // e.g. "2025-08-01T23:59:59-04:00"
  optOutDeadline: string;
  programDecision: "equitable_access" | "inclusive_access" | "no_program";
}

export interface Department {
  id: string;
  name: string;
}

export interface Course {
  id: string;
  name: string;
}

export interface Section {
  active: boolean;
  courseName: string;
  crn: unknown;
  departmentName: string;
  id: string;
  instructor: string;
  name: string;
  notes: string | null;
  posId: unknown;
  userRole: "learner" | "instructor";
}

export function getTerms() {
  return callDecimal<Term[]>("/api/v1/verba_core/terms");
}

export function getDepartments(termId: string) {
  return callDecimal<Department[]>(
    `/api/v1/verba_core/terms/${termId}/departments`
  );
}

export function getCourses(termId: string, departmentId: string) {
  return callDecimal<Course[]>(
    `/api/v1/verba_core/terms/${termId}/departments/${departmentId}/courses`
  );
}

export function getSections(
  termId: string,
  departmentId: string,
  courseId: string
) {
  return callDecimal<Section[]>(
    `/api/v1/verba_core/terms/${termId}/departments/${departmentId}/courses/${courseId}/sections`
  );
}
